export default __webpack_public_path__ + "static/media/photo--sm--88.290579d6.jpg";